// Push-уведомления: токен FCM от нативной обёртки, устройство в реестре notifire, данные пуша.

export type PushPlatform = 'android' | 'ios'

export interface PushToken {
  token: string
  platform: PushPlatform
  /** Разрешение на показ уведомлений; токен выдаётся и без него. */
  granted: boolean
}

/** Устройство продавца: кому notifire шлёт пуши (по id в Mechta ID и/или телефону). */
export interface PushDevice {
  token: string
  platform: PushPlatform
  userId: string
  phone: string
}

/**
 * Разрешение на уведомления в системе телефона: granted — показываются; not_determined — ещё не
 * спрашивали (запрос токена покажет системное окно); denied — запрещены, включить можно только в
 * настройках телефона.
 */
export type PushPermission = 'granted' | 'denied' | 'not_determined'

export function isPushPermission(value: unknown): value is PushPermission {
  return value === 'granted' || value === 'denied' || value === 'not_determined'
}

/** Поля data пуша; deeplink — путь роута приложения (`/order/123`). */
export type PushData = Record<string, string>

/** Путь из пуша, по которому можно перейти внутри приложения, иначе null. */
export function pushRoute(data: PushData): string | null {
  const link = data.deeplink?.trim() ?? ''
  return link.startsWith('/') && !link.startsWith('//') ? link : null
}
